import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.refs.dialog?.addEventListener('click', this.#handleBackdropClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.refs.dialog?.removeEventListener('click', this.#handleBackdropClick);

    // If a theme section refresh detaches an open drawer, release page scroll.
    if (this.refs.dialog?.open) {
      const lockedTop = parseFloat(document.body.style.top || '0');
      this.refs.dialog.close();
      document.body.style.width = '';
      document.body.style.position = '';
      document.body.style.top = '';
      if (Number.isFinite(lockedTop)) {
        window.scrollTo({ top: Math.max(0, -lockedTop), behavior: 'instant' });
      }
    }
  }

  #handleBackdropClick = (event) => {
    const dialog = this.refs.dialog;
    if (!dialog?.open || event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom) {
      this.closeDialog();
    }
  };

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    return this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
